import { Divider, Stack, Typography } from '@mui/material';

import { RoleAccordionBody } from '@/components/permissions/scopeAccordion';
import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';
import { useDAL } from '@/contexts/useDAL';
import { useRoles } from '@/contexts/useRoles';

import type { UpsertApiCredentialsState } from './upsertApiCredentialsFlow';

import { RenameEntityName } from '../wizard/renameEntityName';

export const ApiCredentialsScopesSelection = (
  props: StepProps<UpsertApiCredentialsState>
) => {
  const { rolesMap } = useRoles();
  const dal = useDAL();

  return (
    <>
      <StepContainer
        sx={{ padding: 0 }}
        navigationComponent={
          <RenameEntityName
            label='Credentials name'
            name={props.wizardState.name}
            onSubmit={(name) =>
              props.setWizardState((state) => ({ ...state, name }))
            }
          />
        }
        hideStepper
        onBackClick={props.back}
        backButtonText='Cancel'
        canGoNext={() => {
          if (
            !props.wizardState.roleId ||
            !rolesMap[props.wizardState.roleId]
          ) {
            return false;
          }

          return true;
        }}
        nextButtonText={
          props.wizardState.clientId ? 'Save Changes' : 'Create Credentials'
        }
        onNextClick={async () => {
          const updateEntity = { ...props.wizardState };

          if (updateEntity.clientId) {
            await dal.apiCredentials.update(
              updateEntity.clientId,
              updateEntity
            );
            await props.finish();
          } else {
            const x = await dal.apiCredentials.create(updateEntity);
            props.setWizardState((state) => ({
              ...state,
              clientId: x.apiCredentialsProperties.clientId,
              clientSecret: x.clientSecret,
            }));
            props.setNextStep(props.currentStep.next?.[0]);
          }
        }}
      >
        <Typography
          fontWeight={300}
          className='ml-[100px] mt-[24px] mb-[32px] w-[700px]'
        >{`When code uses your API credentials to call the Eon API, it will have this role's permissions. Keep your account secure by choosing a role with just the permissions needed.`}</Typography>
        <Stack gap='24px' color={'var(--mui-palette-text-primary)'}>
          <Divider />
          <Stack gap='12px' className='ml-[100px]'>
            <Typography variant='body1' className='mb-[24px] mt-[12px]'>
              Edit the permissions these API credentials have by assigning role
            </Typography>
            <RoleAccordionBody
              roleToProjectsMappings={
                props.wizardState.roleId
                  ? {
                      [props.wizardState.roleId]: {},
                    }
                  : {}
              }
              onChange={(roleToProjectsMappings) =>
                props.setWizardState((state) => ({
                  ...state,
                  roleId: Object.keys(roleToProjectsMappings)[0],
                }))
              }
              singleSelect
            />
          </Stack>
        </Stack>
      </StepContainer>
    </>
  );
};
